import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "./descriptorOffline";

class ExtraCharge extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'jobs'
    this.modelName = 'extracharge'
    // this.availablePermissions = ['.view_']
    this.propsList = {
      avatar: 'name',
      pageTitle: 'Extra Charge',
      descriptor,
      masterKey: 'module-merchant-extraCharge',
    }
    
  }
}

export default ExtraCharge